import { getCookie } from './cookies';

export const getBaseLanguage = (langCode) => {
    if (typeof langCode !== 'string' || langCode.trim() === '') {
        return ''; // Handle invalid or empty input
    }

    const parts = langCode.split('-');

    // The first part is usually the base language
    // Convert to lowercase to ensure consistency (e.g., "EN" -> "en")
    return parts[0].toLowerCase();
};

/**
 * Determines the final language and constructs the language query parameter.
 *
 * @returns {{finalLanguage: string, queryParams: string}} An object containing the final language and query parameters.
 */
export const getLanguageAndQueryParams = () => {
    let finalLanguage;

    // Check for language cookie
    const cookieLanguage = getCookie('req_language');

    if (cookieLanguage) {
        finalLanguage = cookieLanguage;
    } else {
        // Fallback to the user's browser language setting
        finalLanguage = getBaseLanguage(navigator.language);
    }

    if (finalLanguage) {
        document.documentElement.setAttribute('lang', finalLanguage);
    }

    let queryParams = finalLanguage ? `?language=${finalLanguage}` : '';

    // Special handling for 'spl.com' host
    if (window.location.host.includes('spl.com')) {
        queryParams = '';
    }

    return { finalLanguage, queryParams };
};
